import { css } from "@emotion/react";

export const labelStyle = css`
  label {
    font-weight: bold;
  }
`;

export const colGutterStyle = css`
  margin-bottom: 8px;
`;

export const fullWidthNumberInputStyle = css`
  width: 100%;
`;

export const imageContainerStyle = css`
  width: 128px;
  height: 128px;
  position: relative;
`;

export const imageEditorStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 128px;
  height: 128px;
`;

export const imageEditorInput = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  border: 1px dashed gray;
`;
